import * as React from 'react'
import { Text, View } from 'react-native'
import styled from '@theme/styled-components'
import theme from '@theme/Theme'

import Button from '@components/button/Button'
import SimpleAlert from '@components/modal/SimpleAlert'

import useI18n from '@i18n/useI18n'

import { ControleFormScheme, ControleFormFields } from '../scheme'
import * as ControleStore from '@store/controle/controle'

const GroupedFormLayout = ({ step, form, onNext, onBack, children, full, last }: ControleLayoutProps) => {
  const i18n = useI18n()

  const [valid, setValid] = React.useState(false)

  const fields = React.useMemo(() => ControleFormFields[step].map((key) => form[key]), [form, step])

  React.useEffect(() => {
    const schema = ControleFormScheme[step as keyof typeof ControleFormFields]

    if (schema) {
      schema
        .validate(form)
        .then(() => setValid(true))
        .catch(() => setValid(false))
    }
  }, [fields, step])

  const selectAnswerMode = () => {
    SimpleAlert.open({
      columnButtons: true,
      buttons: [
        {
          label: i18n.t('screens.controles.form.spaces.nextAllSpaces'),
          onClick: () => {
            const update = form.answerMode === 'allSpaces' ? {} : { reponses: [] }
            ControleStore.actions.setForm({ answerMode: 'allSpaces', ...update })
            SimpleAlert.close()
            onNext()
          },
        },
        {
          label: i18n.t('screens.controles.form.spaces.nextEachSpace'),
          onClick: () => {
            const update = form.answerMode === 'eachSpace' ? {} : { reponses: [] }
            ControleStore.actions.setForm({ answerMode: 'eachSpace', ...update })
            SimpleAlert.close()
            onNext()
          },
        },
      ],
    })
  }

  return (
    <MainContainer>
      {!full && <Title>{i18n.t(`screens.controles.form.${step}.title`, form)}</Title>}

      <FixedContainer>{children}</FixedContainer>

      <Buttons>
        <ButtonContainer>
          <Button
            label={i18n.t('screens.incident.previous')}
            status="active"
            onClick={onBack}
            textOnly
            color="light"
            textColor={theme.colors.primaryText}
          />
        </ButtonContainer>
        <ButtonContainer>
          <Button
            label={i18n.t(last ? 'screens.controles.form.finish' : 'common.validate')}
            status={valid ? 'active' : 'disabled'}
            onClick={step === 'spaces' ? selectAnswerMode : onNext}
          />
        </ButtonContainer>
      </Buttons>
    </MainContainer>
  )
}

export default GroupedFormLayout

const MainContainer = styled(View)`
  flex: 1;
  flex-direction: column;
`

const FixedContainer = styled(View)`
  flex: 1;
`

const Title = styled(Text)`
  ${(props) => props.theme.fonts.Headline};
  margin: 25px 15px;
`

const Buttons = styled(View)`
  flex-direction: row;
  justify-content: space-between;
  background-color: ${(props) => props.theme.colors.background};
`

const ButtonContainer = styled(View)`
  margin: 12px;
`
